import React from 'react';
import { Box, Button, Typography } from '@mui/material';

/**
 * Pagination controls for the calendar
 * 
 * @param {Object} props
 * @param {number} props.currentPage - Current page number
 * @param {number} props.totalPages - Total number of pages
 * @param {Function} props.handlePreviousPage - Handler for previous page
 * @param {Function} props.handleNextPage - Handler for next page
 * @param {boolean} props.isMoveMode - Whether in move mode
 * @returns {JSX.Element}
 */

const PaginationControls = ({
    currentPage,
    totalPages,
    handlePreviousPage,
    handleNextPage,
    isMoveMode
}) => {
    return (
        <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            my: 2,
            gap: 2
        }}>
            <Button
                variant="contained"
                onClick={handlePreviousPage}
                disabled={currentPage === 0}
                color={isMoveMode ? "info" : "primary"}
                sx={isMoveMode ? { borderColor: 'info.main' } : {}}
            >
                Previous
            </Button>

            <Typography variant="body1" color={isMoveMode ? "info.main" : "text.primary"}>
                Page {currentPage + 1} of {totalPages}
                {isMoveMode && " (Move Mode)"}
            </Typography>

            <Button
                variant="contained"
                onClick={handleNextPage}
                disabled={currentPage >= totalPages - 1}
                color={isMoveMode ? "info" : "primary"}
                sx={isMoveMode ? { borderColor: 'info.main' } : {}}
            >
                Next
            </Button>
        </Box>
    );
};

export default React.memo(PaginationControls);